//items-center -mt-2 py-1 px-5 rounded-2xl text-lg border-animation-secondary focus:outline-none border-animation-secondary
import { Fragment, useRef } from 'react';
import { Popover, PopoverButton, PopoverPanel, Transition } from '@headlessui/react';
import { ChevronDownIcon } from 'lucide-react';

interface Props {
  buttonName: string;
  buttonClassName?: string;
  showArrow?: boolean;
  children: any;
}

export function HoverPopover({ buttonName, buttonClassName, showArrow, children }: Props) {
  const buttonRef = useRef<HTMLButtonElement | null>(null);
  const hoverRef = useRef(false);
  const closeTimer = useRef<NodeJS.Timeout | null>(null);

  const clearTimer = () => {
    if (closeTimer.current) {
      clearTimeout(closeTimer.current);
      closeTimer.current = null;
    }
  };

  const onEnter = (open: boolean) => {
    hoverRef.current = true;
    clearTimer();

    if (!open) {
      buttonRef.current?.click();
    }
  };

  const onLeave = (close: () => void) => {
    hoverRef.current = false;
    clearTimer();

    closeTimer.current = setTimeout(() => {
      if (!hoverRef.current) {
        close();
      }
    }, 120);
  };

  return (
    <Popover className='relative'>
      {({ open, close }) => (
        <>
          {/* BUTTON */}
          <PopoverButton
            ref={buttonRef}
            className={`flex items-center gap-x-1 text-lg text-white outline-none focus:outline-none focus:ring-0 ${buttonClassName}`}
            onMouseEnter={() => onEnter(open)}
            onMouseLeave={() => onLeave(close)}
          >
            {buttonName}
            {showArrow && <ChevronDownIcon aria-hidden='true' className='size-5 flex-none text-white' />}
          </PopoverButton>

          {/* PANEL */}
          <Transition
            as={Fragment}
            show={open}
            enter='transition duration-200 ease-out'
            enterFrom='translate-y-1 opacity-0'
            enterTo='translate-y-0 opacity-100'
            leave='transition duration-150 ease-in'
            leaveFrom='translate-y-0 opacity-100'
            leaveTo='translate-y-1 opacity-0'
          >
            <PopoverPanel
              static
              className='absolute left-1/2 z-10 mt-3 w-screen max-w-md -translate-x-1/2 overflow-hidden rounded-3xl bg-white shadow-lg outline outline-1 outline-gray-900/5'
              onMouseEnter={() => onEnter(open)}
              onMouseLeave={() => onLeave(close)}
            >
              {children}
            </PopoverPanel>
          </Transition>
        </>
      )}
    </Popover>
  );
}
